<template>
    <div class="container pull-up">
        <div class="row">
            <div class="col-md-12">
                <div class="card m-b-30">
                    <div class="card-header">
                        <h5 class="m-b-0">
                            <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('item.button.item') }}
                        </h5>
                    </div>
                    <div class="card-body">
                        <!-- Loading indicator -->
                        <v-progress-linear
                          v-if="loading"
                          indeterminate
                          color="primary"
                          class="mb-4"
                        />

                        <!-- Advanced Filter Panel (now always visible, no expansion) -->
                        <v-row class="mb-4">
                          <v-col>
                            <v-autocomplete
                              v-model="filters.category_id"
                              :items="categories"
                              item-text="name"
                              item-value="id" outlined dense
                              :label="$t('item.label.category')"
                              clearable hide-details
                            />
                          </v-col>
                          <v-col>
                            <v-autocomplete
                              v-model="filters.supplier_id"
                              :items="suppliers"
                              item-text="name" outlined dense
                              item-value="id"
                              :label="$t('item.label.supplier')"
                              clearable hide-details
                            />
                          </v-col>
                          <v-col>
                            <v-select
                              v-model="filters.item_type"
                              :items="itemTypes" outlined dense
                              :label="$t('item.label.item_type')"
                              clearable hide-details
                            />
                          </v-col>
<!--                          <v-col cols="auto">
                            <v-range-slider
                              v-model="filters.priceRange"
                              :min="priceSliderMin"
                              :max="priceSliderMax"
                              :step="1"
                              :label="$t('item.label.selling_price')"
                              persistent-hint
                              thumb-label
                              class="mt-6" hide-details
                            >
                              <template v-slot:append>
                                <span>{{ filters.priceRange[0] | currency(' XAF') }} - {{ filters.priceRange[1] | currency(' XAF') }}</span>
                              </template>
                            </v-range-slider>
                          </v-col>-->
                          <v-col cols="auto" class="d-flex align-center mt-">
                            <v-btn color="primary" class="mr-2" @click="applyFilters" :loading="loading">
                              <v-icon left>mdi-filter</v-icon>
                              {{ $t('item.button.filter') }}
                            </v-btn>
                            <v-btn color="default" @click="clearFilters" :disabled="loading">
                              <v-icon left>mdi-filter-remove</v-icon>
                              {{ $t('item.button.clear_filter') }}
                            </v-btn>
                          </v-col>
                        </v-row>

                        <div class="table-responsive mt-3">
                            <data-tables :data="items" center-align :pagination-props="{hideOnSinglePage: true}" v-loading="loading">
                              <el-table-column :label="$t('item.label.photo')" align="center" min-width="50" fixed>
                                <template slot-scope="scope">
                                  <div v-if="scope.row.visual_type === 'colour'" class="ml-3"
                                       style="height: 36px; width: 36px; border-radius: 5px" :style="{backgroundColor: `#${scope.row.hex_colour}`}"/>
                                  <v-avatar fit="cover" v-else size="medium" :src="scope.row.image" tile>
                                    <img :src="scope.row.image" :alt="scope.row.name" width="59px">
                                  </v-avatar>
                                </template>
                              </el-table-column>
                              <el-table-column show-overflow-tooltip prop="code" :label="$t('label.ref')" fixed>
                                <template slot-scope="scope"><strong>{{ scope.row.code }}</strong></template>
                              </el-table-column>
                              <el-table-column show-overflow-tooltip prop="name" :label="$t('label.name')" fixed/>
                              <el-table-column show-overflow-tooltip prop="category.name" :label="$t('item.label.family')"/>
                              <el-table-column :label="$t('item.label.price')" min-width="100" fixed>
                                  <template slot-scope="scope">
                                      <span class="currency">{{ scope.row.unit_price | currency(' XAF') }}</span>
                                  </template>
                              </el-table-column>
                              <el-table-column :label="$t('item.label.purchase_price')">
                                <template slot-scope="scope">
                                  <span class="currency">{{ scope.row.purchase_price | currency(' XAF') }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column prop="item_type" :label="$t('item.label.type.type')">
                                <slot slot-scope="scope">
                                  <el-tag type="success" size="mini">{{ scope.row.item_type.toUpperCase() }}</el-tag>
                                </slot>
                              </el-table-column>
                              <el-table-column :label="$t('label.action')" min-width="150px" fixed="right">
                                  <template v-slot:header="scope">
                                      <el-input ref="searchField" v-model="filters.search" size="mini" autofocus :placeholder="$t('text.search_placeholder')" @input="applyFilters"/>
                                  </template>
                                  <template v-slot:default="scope">
                                      <el-dropdown v-can.event="'item.update'" @click="showEditDialog(scope.row.id)" split-button type="primary" size="small" trigger="click">
                                          <i class="el-icon-edit"></i> {{ $t('button.edit') }}
                                          <el-dropdown-menu slot="dropdown">
                                              <el-dropdown-item v-can.disable="'item.archive'" @click.native="beforeArchive(scope.row.id)">
                                                  <i class="mdi mdi-archive"></i> {{ $t('button.archive') }}
                                              </el-dropdown-item>
                                              <el-dropdown-item v-can.disable="'item.stock'" @click.native="$router.push({name: 'stock-item', params: {item_id: scope.row.id}})">
                                                  <i class="mdi mdi-information"></i> {{ $t('item.button.stock') }}
                                              </el-dropdown-item>
                                          </el-dropdown-menu>
                                      </el-dropdown>
                                  </template>
                              </el-table-column>
                            </data-tables>
                            <div class="pagination-center mt-3">
                              <pagination
                                :total="pagination.total"
                                :page-size="+pagination.per_page"
                                :page-sizes="[10, 15, 30, 40, 100]"
                                :current-page="pagination.current_page"
                                @current-change="handlePageChange"
                                @size-change="handlePageSizeChange"
                              />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-edit-item :display="displayEditDialog" @close="closeEditDialog" @created="newItem"
                          @updated="itemUpdated" :item="item"></create-edit-item>
    </div>
</template>

<script>
import CreateEditItem from './Modal/CreateEditItem'
import ErrorHandlingMixin from '@/mixins/ErrorHandlingMixin.js'
import Pagination from '../_Partials/Pagination.vue'

export default {
  name: 'Index',
  mixins: [ErrorHandlingMixin],
  components: { CreateEditItem, Pagination },
  data () {
    return {
      items: [],
      item: {},
      displayEditDialog: false,
      loading: false,
      filters: {
        category_id: null,
        supplier_id: null,
        item_type: null,
        priceRange: [0, 1000000],
        search: ''
      },
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
      },
      categories: [],
      suppliers: [],
      itemTypes: [
        { text: this.$t('item.label.type.product'), value: 'product' },
        { text: this.$t('item.label.type.service'), value: 'service' }
      ],
      priceSliderMin: 0,
      priceSliderMax: 1000000
    }
  },
  methods: {
    showEditDialog (id) {
      this.item = this.items.find(d => d.id === id)
      this.displayEditDialog = true
    },
    closeEditDialog () {
      this.item = {}
      this.displayEditDialog = false
    },
    newItem (data) {
      this.items.splice(0, 0, data)
    },
    itemUpdated (data) {
      this.items.splice(this.items.indexOf(this.items.find(d => d.id === data.id)), 1, data)
    },
    beforeArchive (id) {
      this.askQuestion(this.$t('item.confirm.archive'), async () => {
        try {
          await this.withLoading(async () => {
            await this.$itemService.archiveItem(id)
            this.showSuccess(this.$t('item.message.archived'))
            this.items.splice(this.items.indexOf(this.items.find(d => d.id === id)), 1)
          }, 'loading')
        } catch (error) {
          // Error is already handled by the global interceptor
          console.log('Component caught error in archiveItem:', error)
        }
      })
    },
    async fetchItems () {
      this.loading = true
      try {
        const params = {
          ...this.filters,
          min_price: this.filters.priceRange[0],
          max_price: this.filters.priceRange[1],
          page: this.pagination.current_page,
          per_page: this.pagination.per_page
        }
        const res = await this.$itemService.getPaginatedItems(params)
        this.items = res.data
        this.pagination.current_page = Number(res.meta.current_page)
        this.pagination.per_page = Number(res.meta.per_page)
        this.pagination.total = Number(res.meta.total)
        this.pagination.last_page = Number(res.meta.last_page)
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in getItems:', error)
      } finally {
        this.loading = false
      }
    },
    handlePageChange (page) {
      this.pagination.current_page = page
      this.fetchItems()
    },
    handlePageSizeChange (size) {
      this.pagination.per_page = Number(size)
      this.pagination.current_page = 1
      this.fetchItems()
    },
    applyFilters () {
      this.pagination.current_page = 1
      this.fetchItems()
    },
    clearFilters () {
      this.filters = {
        category_id: null,
        supplier_id: null,
        item_type: null,
        priceRange: [this.priceSliderMin, this.priceSliderMax],
        search: ''
      }
      this.pagination.current_page = 1
      this.fetchItems()
    },
    async fetchCategories () {
      this.categories = await this.$categoryService.getCategories()
    },
    async fetchSuppliers () {
      this.suppliers = await this.$supplierService.getSuppliers()
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('item.title.item'))
    await Promise.all([
      this.fetchCategories(),
      this.fetchSuppliers()
    ])
    await this.fetchItems()
    setTimeout(() => this.$nextTick(this.$refs.searchField && this.$refs.searchField.focus()), 200)
  },
  created () {
    this.$parent.$on('new-item', this.newItem)
  }
}
</script>

<style scoped>
.pagination-center {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>
